var _linearGradient, _path, _circle, _linearGradient2, _path2, _linearGradient3, _path3, _defs, _clipPath, _linearGradient4, _path4, _defs2, _clipPath2, _linearGradient5, _path5, _defs3, _clipPath3, _linearGradient6, _path6, _defs4, _clipPath4, _linearGradient7, _path7, _defs5, _clipPath5, _linearGradient8, _path8, _defs6, _clipPath6, _linearGradient9, _path9, _defs7, _clipPath7, _linearGradient10, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO2Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 833.3 351.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 273.91,
    y1: 249.08,
    x2: 277.159,
    y2: 249.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0073b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a69e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.2 247c-.4 1.1-1 2.1-1.9 3-.4.4-.9.8-1.3 1.3l.6-.6c.8-1.3 1.7-2.5 2.6-3.7z",
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 284.5,
    r: 21.1,
    fill: "#0574ba",
    opacity: 0.24
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 82.524,
    y1: 176.417,
    x2: 228.334,
    y2: 176.417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0574ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a79f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.4 243.1c-3 0-5.8-1.6-7.3-4.3L83.6 122.2c-1.4-2.6-1.4-5.7.1-8.3 1.5-2.6 4.2-4.1 7.2-4.1H220c3.5 0 6.6 2.1 7.8 5.4 1.2 3.2.4 6.9-2.2 9.2l-33.5 30c-3.4 3.1-8.7 2.8-11.8-.6-3.1-3.4-2.8-8.7.6-11.8l17.2-15.4h-93l46.8 84.5 8.1-38.4-23.8-15.6c-3.9-2.5-4.9-7.7-2.4-11.6 2.5-3.9 7.7-4.9 11.6-2.4l28.5 18.7c2.9 1.9 4.3 5.3 3.6 8.7l-13.9 65.9c-.7 3.4-3.5 6-6.9 6.6-.4.1-.9.1-1.3.1z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 171.496,
    x2: 362.676,
    y2: 171.496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.9 343c-33 0-59.8-26.8-59.8-59.8 0-10.2 2.6-20.2 7.5-29.1.1-.1.2-.3.2-.4l.7-1.1c17.3-27.8 38.8-62.3 38.8-97.7 0-36.1-14.1-70.1-39.6-95.7-25.6-25.6-59.5-39.6-95.7-39.6-36.1 0-70.1 14.1-95.7 39.6-25.5 25.7-39.6 59.7-39.6 95.8s14.1 70.1 39.6 95.7c25.6 25.6 59.5 39.6 95.7 39.6 19.7 0 38.6-4.1 56.4-12.3 4.9-2.3 10.8-.1 13 4.8 2.3 4.9.1 10.8-4.8 13-20.3 9.3-42 14-64.6 14-41.4 0-80.3-16.1-109.6-45.4C16.1 235.3 0 196.4 0 155S16.1 74.7 45.4 45.4C74.7 16.1 113.6 0 155 0c41.4 0 80.3 16.1 109.6 45.4C293.9 74.7 310 113.6 310 155c0 41-23.2 78.2-41.8 108.1l-.5.9c-3.2 5.9-4.9 12.5-4.9 19.3 0 22.1 18 40.1 40.1 40.1s40.1-18 40.1-40.1c0-9.2-3.1-17.9-8.8-25.1-5.6-7-13.5-11.9-22.2-13.9-5.3-1.2-8.6-6.5-7.4-11.8 1.2-5.3 6.5-8.6 11.8-7.4 12.9 3 24.7 10.4 33.1 20.8 8.5 10.6 13.2 23.9 13.2 37.5 0 32.8-26.8 59.6-59.8 59.6z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M463.6 328.8c0 5.5-4.5 10-10 10h-55.1c-5.2 0-9.4-4.2-9.4-9.4 0-2.6 1.1-5.2 3.1-7 25.9-23.8 43.2-43 43.2-59 0-10.5-5.8-16.7-15.6-16.7-4.4 0-8.6 1.6-12.9 4.8-3.7 2.8-8.8 2.6-12-.6-1.8-1.8-2.8-4.4-2.7-7 .1-2.6 1.4-5 3.4-6.6 8.2-6.3 16.7-9.1 27.7-9.1 21 0 35.2 13.5 35.2 33.7 0 19.4-17.6 39.6-33 55.1l-2 2 2.8-.1c5.7-.2 12.9-.2 17.9-.2h9.2c5.7 0 10.2 4.5 10.2 10.1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    overflow: "visible"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#e)",
    fill: "url(#f)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M611.4 263.6l-1.8 2.4 3-.7c13.8-3.1 27.6-7.4 38-11.7 3-1.2 6.5-.7 8.8 1.5l.3.3c2.1 2 3.1 4.9 2.4 7.8-.7 2.8-2.7 5.1-5.5 6-2.1.7-4.3 1.4-6.5 2l-.9.3.1.9c.4 4.3 1.2 8.5 1.9 12.5l.4 2.3 1.5-1.7c.5-.6 1-1.2 1.5-1.7 1.4-1.7 3.4-2.6 5.6-2.8 2.2-.1 4.3.6 6 2.1 1.7 1.5 2.7 3.8 2.7 6 0 2.3-.9 4.5-2.6 6-3.3 3.1-6.6 5.9-9.8 8.5l-.6.5.3.7c3.2 9.1 7.1 16.2 11.8 21.7 2.6 3 2.6 7.5-.1 10.6-.7.8-1.3 1.5-1.9 2.3-1.6 2-4 3.2-6.6 3.1-2.5 0-4.8-1.2-6.3-3.2-9.9-13.2-15.9-32.5-19.5-62.6l-.1-1.3-1.2.4c-2.5.7-5 1.3-7.8 1.7l-.9.2v45.9l5.8-2.1c2.3-.8 4.9-.6 7.1.7 2.1 1.3 3.5 3.5 3.9 6v.3c.5 3.7-1.6 7.3-5.1 8.7-11.2 4.5-17.1 7-21 8.7-3.6 1.7-7.8.5-10-2.6-.5-.7-.9-1.3-1.5-2-2.1-2.8-2.4-6.5-.7-9.3 2.3-3.7 3.5-8.1 3.5-12.7v-51l-.4-.3c-2-1.7-4.5-3.7-7.1-5.7-2.9-2.2-3.8-6.1-2.3-9.2 6.1-8.9 12-20.6 15.4-30.6 1.2-3.7 4.7-6.1 8.6-6.1.6 0 1.2.1 1.8.1 2.9.6 5.2 2.4 6.6 5 1.3 2.6 1.3 5.6 0 8.2l-.2.7.7 1.1h35c4.5 0 8.2 3.7 8.2 8.2v.5c0 4.5-3.7 8.2-8.2 8.2h-43l-.3.6c-3.1 6-6 10.6-9 14.6z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "url(#i)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M593.5 269.8c1.2 1.2 1.8 2.8 1.7 4.7-1.1 42.8-2.2 62.9-5.9 68.3-2.9 4.4-5.9 5.7-9.8 6.5-2.2.4-5.1.7-8.8.7-2.7-.1-5-1.9-5.5-4.6-.2-1.3-.5-2.6-.9-3.9-.4-1.6-.1-3.4.9-4.7 1-1.3 2.5-2.1 4.2-2.1 2.2 0 3.7-.8 5.2-2.8 2.1-3.2 3.1-14.8 3.9-46v-1.1h-9.6l-.1 1c-.6 12.2-2.8 30.5-9.7 47.9-1.1 2.8-2.3 5.5-3.8 8.3-1.1 2.2-3.1 3.7-5.5 4.3-2.5.6-5 0-7.1-1.6-3.3-2.5-4.4-7-2.5-10.6 11.1-21.3 12.6-43.4 12.6-60.4v-19.6h-3.5c-4.8 0-8.8-3.5-9.2-8-.2-2.5.7-4.9 2.5-6.7 1.6-1.6 3.8-2.5 6.1-2.5h15.1l-.3-1.4c-.5-2.3-1.2-4.8-2-7.3-.7-2.3-.5-4.8.6-6.9 1.1-2 2.8-3.5 5-4.2 4.6-1.4 9.1 1 10.7 5.1.2.5.4.9.5 1.4l.2.5c.8 2.1.7 4.4-.3 6.4s-2.6 3.5-4.7 4.2l-6.2 2.2h20c4.8 0 8.7 3.9 8.7 8.6 0 .3-.4 7.9-10 8.7h-16.6v13.7h20c1.4-.1 2.9.6 4.1 1.9z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    overflow: "visible"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#k)",
    fill: "url(#l)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M833.3 272.4c0 4.9-4 9-9 9h-10.1v47.1c0 11.2-2.1 16-8.5 18.8-5.7 2.6-13.4 3.1-20.2 3.3-4.2.2-7.9-2.7-9-6.8l-.2-.9c-.7-2.8-.1-5.7 1.6-7.9 1.7-2.2 4.2-3.4 7-3.4h5.2c2.4 0 4.6-.4 4.6-3.7v-46.5h-31c-4.9 0-8.9-4-8.9-9 0-4.9 4-8.9 8.9-8.9h60.6c5 0 9 4 9 8.9z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#n)",
    fill: "url(#o)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M829.6 231.9c0 5-4 9-8.9 9h-50.8c-5 0-9-4-9-9 0-4.9 4-8.9 9-8.9h50.8c4.9 0 8.9 4 8.9 8.9z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    overflow: "visible"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#q)",
    fill: "url(#r)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M749.2 258.6c0 1.7-.5 3.5-1.5 5-2.6 3.8-5.4 7.6-8.4 11.5l-.2.3v66.8c0 4.9-4 8.9-9 8.9h-1.2c-4.9 0-8.9-4-8.9-8.9v-45.1l-2.7 2.5c-1.9 1.7-4.3 2.5-6.8 2.3-2.5-.2-4.8-1.5-6.3-3.5-.5-.7-1-1.3-1.5-1.9-3-3.8-2.4-9.2 1.4-12.3 10.6-8.8 20.4-19.7 27.8-30.7 2.4-3.6 6.8-5 10.7-3.5l.9.3c2.6 1 4.5 3.1 5.4 5.7.2.8.3 1.7.3 2.6z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    overflow: "visible"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#t)",
    fill: "url(#u)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M740.4 232.3c-7.3 8.1-15.4 15.8-23.5 22.3a8.89 8.89 0 01-6.9 1.8c-2.5-.4-4.7-1.8-6.2-4.1l-.2-.3c-2.6-3.9-1.7-9.2 1.9-12 7.5-5.8 15-12.9 20.7-19.6 1.8-2.1 4.3-3.3 6.9-3.3 1.2 0 2.3.2 3.4.7l.6.3c2.7 1.1 4.7 3.4 5.3 6.3.7 2.9 0 5.7-2 7.9z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    overflow: "visible"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 195.787,
    y1: 284.672,
    x2: 904.985,
    y2: 284.672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a79f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0574ba"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#w)",
    fill: "url(#x)",
    d: "M195.8 151.6H905v266.2H195.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2Full);
export default __webpack_public_path__ + "static/media/o2-full.f3bbee6b309af1bb81030ea30617851c.svg";
export { ForwardRef as ReactComponent };